export default __webpack_public_path__ + "static/media/Snd_TryT.7e4fdcb4.mp3";